'use strict';

var FaresOptimizerDashboardPanelDirective = function FaresOptimizerDashboardPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-optimizer-dashboard-panel.html'),
    scope: true
  };
};
FaresOptimizerDashboardPanelDirective.$inject = [];
module.exports = FaresOptimizerDashboardPanelDirective;